/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  ScheduleTemplateListFilter,
  ScheduleTemplateRestService,
  ScheduleType,
} from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';

import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';

import { Observable } from 'rxjs';

import {
  ScheduleTemplateFinderDialogConfig,
  ScheduleTemplateListItem,
} from './schedule-template-finder.model';

@Injectable()
export class ScheduleTemplatesFinderBusinessService
  implements InitDialogViewService<ScheduleTemplateFinderDialogConfig> {

  sourceOfficeId: ID;

  constructor(private scheduleTemplateRest: ScheduleTemplateRestService,
              private dictionaryService: DictionaryService) {
  }

  initDialogView(route: DialogRouteSnapshot<ScheduleTemplateFinderDialogConfig>): any {
    this.sourceOfficeId = route.input.sourceOfficeId;
    return {
      sourceOfficeId: this.sourceOfficeId,
      scheduleType: this.dictionaryService.getByEnum(ScheduleType),
    };
  }

  findAllByOffice(filter?: ScheduleTemplateListFilter): Observable<ScheduleTemplateListItem[]> {
    return this.scheduleTemplateRest.findAllByOffice(this.sourceOfficeId, filter);
  }
}
